import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

const Earn = lazy(() => import('@/components/blockpot/earn'))

export const Route = createFileRoute('/earn')({
    component: EarnPage,
})

function EarnPage() {
    return (
        <Earn />
    )
}